import React from "react";
import { Box } from "@chakra-ui/react";
import Dashboard from "./Dashboard";

const SuperAdmin = () => {
  return (
    <Box px={{ base: 2, md: 4 }} pb={{ base: 2, md: 4 }}>
      <Box mt={{ base: 2, md: 4 }}>
        <Dashboard />
      </Box>
    </Box>
  );
};

export default SuperAdmin;
